// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26YKJ","placeholdersHeader":"styles_placeholdersHeader__2t_fH","editorStyle":"styles_editorStyle__2n7w3","placeholdersBox":"styles_placeholdersBox__1IzKY"};